import { ElementTransformer } from '@lexical/markdown';
import {
  $isDiffHunkNode,
  DiffHunkNode,
} from '../customNodes/DiffHunkNode/DiffHunkNode';

const DIFF_LINE_REGEX = /^[+-] /;

export const DIFF_HUNK: ElementTransformer = {
  dependencies: [DiffHunkNode],

  export: node => {
    if (!$isDiffHunkNode(node)) {
      return null;
    }

    return `\`\`\`diff\n${node.__diffContent}\n\`\`\``;
  },

  regExp: DIFF_LINE_REGEX,

  replace: () => {
    // Import is handled by DiffHunkPlugin post-processing (same pattern as TABLE).
    return;
  },

  type: 'element',
};
